import { EmojiNavYoutubeIcon , EmojiNavNatureIcon , EmojiIcon } from "../components/icons"

export const EmojiIcons = [
    {
        category : 'YOUTUBE' ,
        icon : <EmojiNavYoutubeIcon/> ,
        items:[
            {
                url : 'https://yt3.ggpht.com/OhBw01gTLTGAuk2zRq9ls48AO1jcMQA_bIW8CdF-hROGXtKi7CYLU4EUI68JpztTX0mvNg=w48-h48-c-k-nd' ,
            } ,
            {
                url : 'https://yt3.ggpht.com/Fw4rdTlWPq8YomP8WS9dY4nObuU5r8bqTNiKCtw7cjS_T6ULryiihu-fTkqRuDNNiC6kWC0=w48-h48-c-k-nd'
            } ,
            {
                url : 'https://yt3.ggpht.com/LfXGKUk1-6jnvn431RSc53VS1S3oXbYzy9h4ANkd9V6do4QJ7I77B-FHarhefk3gCK-a6g=w48-h48-c-k-nd' ,
            },
            {
              url : 'https://yt3.ggpht.com/FinjQDXgPOsKAw8fKMYDEZXk5doCAbav1AVqQjqfBvj2N1nAEWWoIXY9awFLaW6M_ExZqzU=w48-h48-c-k-nd' ,
            } ,
            {
              url : 'https://yt3.ggpht.com/MJAydyIqpYaA5RmXzjN_dmleyyvhWBmBktt-Ukwm6c6RJ6nRWyBKniSbidB8mGxu0OOe9w=w48-h48-c-k-nd',
            }
        ]        
    } ,
    {
        category : 'PEOPLE' ,
        icon : <EmojiIcon/> ,
        items : [
            {
                url : 'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f600.png' 
            } ,
            {
                url : 'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f970.png'
            } ,
            {
                url :'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f60e.png'
            } ,
            {
                url :'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f97a.png'
            } ,
            {
                url :'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f62a.png'
            }
        ]
    } ,
    {
        category : 'NATURE' ,
        icon : <EmojiNavNatureIcon/> ,
        items : [
            {
                url : 'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f435.png' ,
            } ,
            {
                url : 'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f412.png'
            } ,
            {
                url : 'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f436.png' 
            } ,
            {
                url :'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u1f427.png' 
            } ,
            {
                url :'https://www.youtube.com/s/gaming/emoji/7ff574f2/emoji_u2618.png'
            }
        ]
    } ,
]